<template>
    <Card>
        <div class="main-claim">
            <div :class="getStatusBackgroundColorClass(claim.status) + ' status-bar'">
                <StatusIcon :status="claim.status" class="status-icon"></StatusIcon>
                <StatusIcon :status="claim.status" class="status-icon-background"></StatusIcon>
                <div class="status-name">{{claim.title + ': ' + getStatusTitle(claim.status)}}</div>
            </div>
            <div class="info-bar" v-html="body"></div>

            <!-- <transition name="fade">
                <div :class="'reply-bar ' + (reply.type === 'supporting' ? 'supporting': 'opposing')" v-if="reply">
                    <h3 v-if="reply === 'supporting'">Agree with Claim</h3>
                    <h3 v-if="reply === 'opposing'">Disagree with Claim</h3>
                    <NewClaimForm class="new-claim" @change="syncReply"></NewClaimForm>
                </div>
            </transition> -->
            <div class="actions-bar">
                <div class="action-button">
                    <AgreeBorderButton @click="agreeReply()" v-tooltip.top-center="'Add Supporting Claim'"></AgreeBorderButton>
                </div>
                <div class="action-button">
                    <DisagreeBorderButton @click="disagreeReply()" v-tooltip.top-center="'Add Opposing Claim'"></DisagreeBorderButton>
                </div>
            </div>
        </div>
    </Card>
</template>

<script>
    // import BorderButton from './BorderButton';
    import AgreeBorderButton from './AgreeBorderButton.vue';
    import DisagreeBorderButton from './DisagreeBorderButton.vue';
    import Card from '../components/Card.vue';
    import Clickable from '../components/Clickable.vue';
    import StatusIcon from '../components/StatusIcon.vue';
    import NewClaimForm from '../components/NewClaimForm.vue';
    import Status from '../utility/Status';
    import { getStatusBackgroundColorClass, getStatusIconClass, getStatusTitle } from '../utility/StatusGenerator';
    import marked from 'marked';
    import { DEFAULT } from '../utility/Status';

    export default {
        methods: {
            getStatusBackgroundColorClass: getStatusBackgroundColorClass,
            getStatusIconClass: getStatusIconClass,
            getStatusTitle: getStatusTitle,
            agreeReply: function() {
                this.$emit('newSupportingReply');
            },
            disagreeReply: function() {
                this.$emit('newOpposingReply');
            },
            // createReply: function(reply) {
            //     this.$emit('newReply', reply);
            // }
        },
        props: ['claim'],
        data() {
            return {};
        },
        computed: {
            body() {
                return marked(this.claim.body, { sanitize: true });
            }
        },
        components: {
            AgreeBorderButton,
            DisagreeBorderButton,
            // BorderButton,
            Card,
            Clickable,
            StatusIcon,
            NewClaimForm
        }
    }
</script>

<style scoped lang="scss">
    .main-claim {
        .status-bar {
            position: relative;

            display: flex;
            flex-direction: row;
            align-items: center;

            height: $space-128;
            width: 100%;

            color: white;

            font-size: $space-64;
            overflow: hidden;

            .status-icon {
                width: $space-128;
                height: $space-128;
            }

            .status-icon-background {
                width: $space-512;
                height: $space-512;
                position: absolute;
                left: -$space-128;
                top: -$space-128;
                opacity: 0.1;
            }
        }

        .info-bar {
            text-align: left;
            min-height: $space-256;
            padding: $space-32;
            box-sizing: border-box;
        }

        .reply-bar {
            box-sizing: border-box;
            padding: $space-32;

            &.fade-enter-active, &.fade-leave-active {
                transition: all 0.5s;
            }
            &.fade-leave-active {
                transition: all 0.25s;
            }
            &.fade-enter, &.fade-leave-to {
                opacity: 0;
                background-color: $light-gray;
            }

            &.supporting {
                color: white;
                background-color: $trueColor;
            }
            &.opposing {
                color: white;
                background-color: $falseColor;
            }

            h3 {
                margin-top: 0;
                text-align: left;
            }
        }

        .actions-bar {
            height: $space-64;
            background-color: $gray;

            display: flex;
            flex-direction: row;

            .action-button {
                background-color: $off-white;
                height: 100%;
                width: 50%;

                border: 1px solid $gray;
            }
        }
    }
</style>